/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Right_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Top Right" |
*
* @param {Position_Top_Right_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_right_title = /** @type {((inputs?: Position_Top_Right_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Right_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : En Haut a Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Oben rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: in alto a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Положение: Верхний правый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Arriba a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：右上角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置: 右上")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थान: ऊपर दाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Canto superior direito")
	return /** @type {LocalizedString} */ ("Position: Top Right")
});